import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const TierPill = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'tier' && prop !== 'pillSize' && prop !== 'fullWidth',
})<{ tier: App.LuxLoyaltyTier; pillSize: 'small' | 'medium'; fullWidth?: boolean }>(({
  theme,
  tier,
  pillSize,
  fullWidth = false,
}) => {
  const isSmall = pillSize === 'small';
  const baseBorderRadius = typeof theme.shape.borderRadius === 'number' ? theme.shape.borderRadius : 4;

  return {
    alignItems: 'center',
    flexShrink: 0,
    maxWidth: '100%',
    borderRadius: baseBorderRadius * 4,
    fontSize: theme.typography.pxToRem(isSmall ? 12 : 13),
    fontWeight: theme.typography.fontWeightRegular,
    lineHeight: 1,
    background: theme.palette.loyaltyTiers[tier].gradient,
    color: theme.palette.loyaltyTiers[tier].contrastText,
    ...(fullWidth
      ? {
          display: 'flex',
          width: '100%',
          justifyContent: 'center',
          alignSelf: 'stretch',
        }
      : {
          display: 'inline-flex',
          width: 'fit-content',
          alignSelf: 'flex-start',
        }),
    ...(tier === 'infinite'
      ? {
          minHeight: isSmall ? 24 : 32,
          padding: theme.spacing(isSmall ? 0.5 : 0.75, isSmall ? 1 : 1.5),
          ...(fullWidth && {
            padding: theme.spacing(isSmall ? 0.75 : 1, isSmall ? 1 : 1.5),
          }),
        }
      : {
          height: isSmall ? 24 : 32,
          padding: theme.spacing(0.75, isSmall ? 1 : 1.5),
          gap: theme.spacing(0.75),
        }),
  };
});

export default TierPill;
